import React from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleProp,
  StyleSheet,
  useWindowDimensions,
  View,
  ViewStyle,
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import { GAME_OPERATION_TYPE } from '../../constants/constants';

const backgroundImage = require('../../resources/images/patternV2.jpg');
const largeBackgroundImage = require('../../resources/images/webBackV2.png');
const largeHorizontalBackgroundImage = require('../../resources/images/horizontalBack.png');

const beeRight = require('../../resources/images/backgroundBeeRightv2.png');

const plusBackground = require('../../resources/images/plusBackground.png');
const minusBackground = require('../../resources/images/minusBackground.png');
const multiplyBackground = require('../../resources/images/multiplyBackground.png');
const divideBackground = require('../../resources/images/divideBackground.png');

const backgroundImages: Record<GAME_OPERATION_TYPE, any> = {
  [GAME_OPERATION_TYPE.ADDITION]: plusBackground,
  [GAME_OPERATION_TYPE.SUBTRACTION]: minusBackground,
  [GAME_OPERATION_TYPE.MULTIPLICATION]: multiplyBackground,
  [GAME_OPERATION_TYPE.DIVISION]: divideBackground,
};

interface IComponentWrapperProps {
  children: React.ReactNode;
  hasInset: boolean;
  hasBackground?: boolean;
  backgroundColor?: string;
  hasScroll?: boolean;
  style?: StyleProp<ViewStyle>;
  scrollEnabled?: boolean;
  horizontalBackground?: boolean;
  hideBee?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  contentContainerStyle?: StyleProp<ViewStyle>;
  showOperand?: boolean;
  operand?: GAME_OPERATION_TYPE;
}
const ComponentWrapper = ({
  hasInset,
  children,
  hasBackground = true,
  backgroundColor = 'white',
  hasScroll = true,
  style,
  scrollEnabled = true,
  horizontalBackground = false,
  hideBee,
  containerStyle,
  contentContainerStyle,
  showOperand = false,
  operand,
}: IComponentWrapperProps) => {
  const inset = useSafeAreaInsets();
  const { width } = useWindowDimensions();
  const isMobileWeb = Platform.OS === 'web' && width <= 768;

  const renderBees = () => {
    if (hideBee) {
      return null;
    }
    if (!horizontalBackground) {
      return (
        <>
          <Image
            resizeMode="cover"
            style={[styles.beeRight, isMobile && { bottom: -140, right: 100 }]}
            source={beeRight}
          />
        </>
      );
    }
    return null;
  };

  const renderOperandMobileBackground = (operation: GAME_OPERATION_TYPE) => {
    if (!isMobile || !showOperand || !operand) {
      return null;
    }
    return (
      <Image
        resizeMode="contain"
        style={styles.operandImage}
        source={backgroundImages[operation]}
      />
    );
  };

  if (!hasBackground) {
    return (
      <View style={[styles.container, { backgroundColor }, containerStyle]}>
        <View style={styles.image}>
          <ScrollView
            scrollEnabled={scrollEnabled}
            contentContainerStyle={[
              {
                alignItems: 'center',
                paddingTop: hasInset ? inset.top : 0,
                paddingBottom: hasInset ? inset.bottom : 0,
              },
              contentContainerStyle,
            ]}
            style={[styles.innerContainer, style]}
          >
            {children}
          </ScrollView>
        </View>
      </View>
    );
  }
  return (
    <View style={[styles.container, containerStyle]}>
      <ImageBackground
        imageStyle={{ height: isMobileWeb ? '140%' : '100%' }}
        resizeMode="cover"
        style={styles.image}
        source={
          !isMobile
            ? horizontalBackground
              ? largeHorizontalBackgroundImage
              : largeBackgroundImage
            : backgroundImage
        }
      >
        {operand && renderOperandMobileBackground(operand)}
        {renderBees()}
        {hasScroll ? (
          <ScrollView
            contentContainerStyle={[
              {
                alignItems: 'center',
                paddingTop: hasInset ? inset.top : 0,
                paddingBottom: hasInset ? inset.bottom : 0,
              },
              contentContainerStyle,
            ]}
            scrollEnabled={scrollEnabled}
            style={[styles.innerContainer, style]}
          >
            {children}
          </ScrollView>
        ) : (
          <View
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: hasInset ? inset.top : 0,
              paddingBottom: hasInset ? inset.bottom : 0,
            }}
          >
            {children}
          </View>
        )}
      </ImageBackground>
    </View>
  );
};

export { ComponentWrapper };

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    position: 'relative',
  },
  image: {
    flex: 1,
  },
  innerContainer: {
    flex: 1,
    paddingHorizontal: 20,
    position: 'relative',
  },
  beeRight: {
    width: 280.47,
    height: 283.61,
    position: 'absolute',
    bottom: '1%',
    right: '15%',
  },

  operandImage: {
    position: 'absolute',
    top: 60,
    right: 20,
  },
});
